import { Stack as MuiStack, StackProps } from '@mui/material';

export const Stack = (props: StackProps) => {
    return <MuiStack {...props} />;
};
